// extracted by mini-css-extract-plugin
export var component = "Header-module--component--IzF1d";
export var header = "Header-module--header--3fkf5";
export var label = "Header-module--label--G7F0j";
export var menuContainer = "Header-module--menuContainer--sYRHs";
export var select = "Header-module--select--Ni1SX";
export var signout = "Header-module--signout--kGJcG";